/* Traversine landing */
(function () {
  'use strict';
  if (window.__tlLanding) return;
  window.__tlLanding = true;

  function formatMoney(cents, format) {
    var fmt = format || '€{{amount_with_comma_separator}}';
    var value = (cents / 100);
    function sep(n, dec, thou, dp) {
      var parts = n.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return sep(value, '.', ',', 2);
        case 'amount_no_decimals': return sep(value, '.', ',', 0);
        case 'amount_with_comma_separator': return sep(value, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return sep(value, ',', '.', 0);
        case 'amount_with_apostrophe_separator': return sep(value, '.', "'", 2);
        default: return sep(value, ',', '.', 2);
      }
    }).replace(/<[^>]*>/g, '');
  }

  function initGallery(root) {
    var slides = root.querySelectorAll('[data-tl-slide]');
    var thumbs = root.querySelectorAll('[data-tl-thumb]');
    function show(id) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.tlSlide === String(id)); });
      thumbs.forEach(function (t) { var on = t.dataset.tlThumb === String(id); t.classList.toggle('is-active', on); t.setAttribute('aria-current', on ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.tlThumb); }); });
    root.tlShow = show;
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-tl-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = root.dataset.moneyFormat;
    var form = root.querySelector('form[data-tl-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btn = root.querySelector('[data-tl-add]');
    var btnLabel = btn.querySelector('[data-tl-add-label]');
    var priceNow = root.querySelectorAll('[data-tl-price]');
    var priceWas = root.querySelector('[data-tl-compare]');
    var save = root.querySelector('[data-tl-save]');
    var gallery = root.querySelector('[data-tl-gallery]');
    var labels = { add: btn.dataset.labelAdd, soldout: btn.dataset.labelSoldout };

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-tl-option]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === null || opts[i] === undefined || o === opts[i]; }); });
    }
    function markAvailability(opts) {
      root.querySelectorAll('[data-tl-option]').forEach(function (fs, idx) {
        fs.querySelectorAll('.tl-pill').forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[idx] = val;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
        var c = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-tl-option-value]');
        if (c && out) out.textContent = c.value;
      });
    }
    function update() {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) { btn.disabled = true; btnLabel.textContent = labels.soldout; return; }
      idInput.value = v.id;
      priceNow.forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      if (priceWas) {
        var has = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.hidden = !has; if (save) save.hidden = !has;
        if (has) {
          priceWas.textContent = formatMoney(v.compare_at_price, moneyFormat);
          if (save) save.textContent = save.dataset.template.replace('[amount]', formatMoney(v.compare_at_price - v.price, moneyFormat));
        }
      }
      btn.disabled = !v.available;
      btnLabel.textContent = v.available ? labels.add : labels.soldout;
      if (v.featured_media && gallery && gallery.tlShow) gallery.tlShow(v.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('tl:variant', { detail: { variant: v, options: opts } }));
    }
    root.querySelectorAll('[data-tl-option] input').forEach(function (i) { i.addEventListener('change', update); });

    var qty = root.querySelector('[data-tl-qty]');
    if (qty) {
      var qi = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qi.value, 10) || 1;
          n = b.dataset.step === 'up' ? n + 1 : Math.max(1, n - 1);
          qi.value = n;
        });
      });
    }

    document.addEventListener('tl:choose-option', function (e) {
      var name = (e.detail.value || '').toLowerCase();
      var input = Array.prototype.find.call(root.querySelectorAll('[data-tl-option] input'), function (i) { return i.value.toLowerCase() === name; });
      if (input) { input.checked = true; update(); root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }
    });

    var sticky = document.querySelector('[data-tl-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var sb = sticky.querySelector('button');
      sb.addEventListener('click', function () { if (!btn.disabled) { if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); } });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(btn);
      document.addEventListener('tl:variant', function (e) { sb.disabled = !e.detail.variant.available; });
    }

    /* Add to cart via AJAX (/cart/add.js) instead of a native form POST.
       Bundle / quantity-break apps (e.g. Pumper Bundles) hook into the theme's AJAX
       add-to-cart request to apply the selected bundle quantity; a native POST bypasses them.
       Registered on document so app handlers attached to the form run first: if an app
       already handled the submit (preventDefault), we do nothing. */
    var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var busy = false;
    document.addEventListener('submit', function (e) {
      if (e.target !== form || e.defaultPrevented) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (busy) return;
      busy = true; btn.setAttribute('aria-busy', 'true');
      var original = btnLabel.textContent;
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        window.location.href = root_url + 'cart';
      }).catch(function (err) {
        busy = false; btn.removeAttribute('aria-busy');
        btnLabel.textContent = (err && (err.description || err.message)) || 'Errore, riprova';
        setTimeout(function () { btnLabel.textContent = original; }, 3500);
      });
    });
    update();
  }

  function initStack(el) {
    if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.45 });
    io.observe(el);
  }

  /* Calcolatore: il prezzo delle monouso si inserisce per confezione da 100 (tl-pack);
     resta compatibile con il vecchio cursore a prezzo unitario (tl-unit). */
  function initCalc(el) {
    var perDay = el.querySelector('[name="tl-per-day"]');
    var unit = el.querySelector('[name="tl-unit"]');
    var pack = el.querySelector('[name="tl-pack"]');
    var pads = el.querySelector('[name="tl-pads"]');
    var fmt = el.dataset.moneyFormat;
    var basePrice = parseInt(el.dataset.padPrice, 10) || 0;
    function out(name, val) { var o = el.querySelector('[data-out="' + name + '"]'); if (o) o.textContent = val; }
    function calc() {
      var d = parseFloat(perDay.value), p = parseInt(pads.value, 10);
      var u = pack ? parseFloat(pack.value) / 100 : parseFloat(unit.value);
      var yearly = Math.round(d * u * 365 * 100);
      var washable = basePrice * p;
      out('per-day', d); out('unit', formatMoney(Math.round(u * 100), fmt)); out('pads', p);
      if (pack) out('pack', formatMoney(Math.round(parseFloat(pack.value) * 100), fmt));
      out('yearly', formatMoney(yearly, fmt)); out('washable', formatMoney(washable, fmt));
      out('diff', formatMoney(Math.max(0, yearly - washable), fmt));
    }
    [perDay, unit, pack, pads].forEach(function (i) { if (i) i.addEventListener('input', calc); });
    document.addEventListener('tl:variant', function (e) { basePrice = e.detail.variant.price; calc(); });
    calc();
  }

  function initSizes(el) {
    el.querySelectorAll('[data-tl-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('tl:choose-option', { detail: { value: b.dataset.tlSize } }));
      });
    });
    document.addEventListener('tl:variant', function (e) {
      var opts = e.detail.options.map(function (o) { return (o || '').toLowerCase(); });
      el.querySelectorAll('[data-tl-size]').forEach(function (b) { b.classList.toggle('is-selected', opts.indexOf(b.dataset.tlSize.toLowerCase()) > -1); });
    });
  }

  function initJump(a) {
    a.addEventListener('click', function (ev) {
      var t = document.querySelector('[data-tl-product]');
      if (!t) return;
      ev.preventDefault();
      t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function boot(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-tl-gallery]:not([data-tl-ready])').forEach(function (g) { g.dataset.tlReady = '1'; initGallery(g); });
    s.querySelectorAll('[data-tl-stack]:not([data-tl-ready])').forEach(function (g) { g.dataset.tlReady = '1'; initStack(g); });
    s.querySelectorAll('[data-tl-calc]:not([data-tl-ready])').forEach(function (g) { g.dataset.tlReady = '1'; initCalc(g); });
    s.querySelectorAll('[data-tl-sizes]:not([data-tl-ready])').forEach(function (g) { g.dataset.tlReady = '1'; initSizes(g); });
    s.querySelectorAll('[data-tl-jump]:not([data-tl-ready])').forEach(function (g) { g.dataset.tlReady = '1'; initJump(g); });
    s.querySelectorAll('[data-tl-product]:not([data-tl-ready])').forEach(function (g) { g.dataset.tlReady = '1'; initProduct(g); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
